/* eslint-disable react/prop-types */
import React from "react";
import "./CalculationPage.scss";
import { FilterArea, Dropdown, DataTable, PageLayout } from "@sia/style-guide";
import { generateHeaderRows } from "./helpers";
import { parseTableData } from "./data/dataParsing";
import SideBarWithLinks from "components/SideBarWithLinks.js";
import Page from "../Page";

export default function CalculationPage({ translate, filters, setFilters, data, profitMarginInputs, onProfitMarginChange }) {
  const barchartTableHeaderRows = generateHeaderRows(translate, null);
  const barchartTableDataRows = parseTableData(data, translate, profitMarginInputs, onProfitMarginChange);
  const displayedFilters = filters.filter((filter) => ["surveyYears", "dataBasis"].includes(filter.id));
  return (
    <Page className="landing" title="calculation page">
      <PageLayout variant="layout_25_50_25">
        <div></div>
        <div className="center">
          <h2>{translate("benchmarking.calculations-page.header.title")}</h2>
          <p className="sia-text-10">{translate("benchmarking.calculations-page.header.paragraph-1")}</p>
          <p className="sia-text-10">{translate("benchmarking.calculations-page.header.paragraph-2")}</p>
        </div>
        <div className={"right-column"}>
          <SideBarWithLinks />
        </div>
      </PageLayout>
      <div className="benchmarking-salary-container sia-padding-02-left sia-padding-02-right">
        <p className="calculation-title sia-text-15 sia-padding-05-top sia-padding-03-bottom">{translate("benchmarking.calculations-page.title")}</p>
        {/* <FilterArea
          translate={translate}
          initialFilters={filters}
          onFiltersUpdate={(filterAreaState) => {
            setFilters((state) => ({ ...state, filters: filterAreaState, newest: true }));
          }}
        /> */}
        <div className="calculation-filters sia-padding-03-bottom">
          {displayedFilters.map((filter) => (
            <div key={filter.id} className="calculation-filter">
              <Dropdown
                id={filter.id}
                label={filter.label}
                items={filter.items}
                value={filter.value}
                onChange={(event, selectedItem) => {
                  setFilters((prev) => ({
                    ...prev,
                    filters: prev.filters.map((f) =>
                      f.id === filter.id
                        ? {
                            ...f,
                            value: selectedItem,
                          }
                        : f
                    ),
                    newest: true,
                  }));
                }}
              />
            </div>
          ))}
        </div>
        <React.Fragment>
          <div className="sia-padding-03-top sia-barchart-table">
            <DataTable headerRows={barchartTableHeaderRows} dataRows={barchartTableDataRows} />
          </div>
        </React.Fragment>
      </div>
    </Page>
  );
}
